<template>
  <div class="container">
    <div
      class="voice-displayer"
      v-if="!editing"
      :data-reader="item.queryParams.speaker"
    >
      <div class="reader" v-if="readerData">
        <div class="figure-wrapper">
          <div class="figure">
            <img :src="$handleAssetsUrl(readerData.iconUrl)" alt="" />
          </div>
          <div :class="badgeClassName" v-if="readerData.aiType"></div>
        </div>
        <div class="name">{{ readerData.label }}</div>
      </div>
      <div class="content" @click.stop>
        <div class="text-wrapper" @click="select">
          <div class="text" :class="{ active: selected }">
            <div class="arrow-outer">
              <svg
                class="arrow-inner"
                xmlns="http://www.w3.org/2000/svg"
                width="10.41"
                height="17.55"
                viewBox="0 0 10.41 17.55"
                version="1.1"
                v-show="selected"
              >
                <title>小三角 带描边</title>
                <path
                  class="cls-1"
                  fill="#e8ebfc"
                  d="M-13.66,35.84v13.5l-8.9-5a2,2,0,0,1-.76-2.72,2,2,0,0,1,.76-.76Z"
                  transform="translate(24.07 -34.16)"
                />
                <path
                  class="cls-2"
                  fill="#5778fb"
                  d="M-13.66,35.33v1.08l-8.65,4.87a1.42,1.42,0,0,0-.57.57A1.47,1.47,0,0,0-23,43a1.52,1.52,0,0,0,.71.9l8.65,4.87v1.07a.5.5,0,0,1-.24-.06l-8.9-5A2.49,2.49,0,0,1-24,43.26a2.47,2.47,0,0,1,.23-1.9,2.41,2.41,0,0,1,.95-1l8.9-5A.44.44,0,0,1-13.66,35.33Z"
                  transform="translate(24.07 -34.16)"
                />
              </svg>
              <svg
                class="arrow-inner"
                xmlns="http://www.w3.org/2000/svg"
                width="9.92"
                height="13.5"
                version="1.1"
                viewBox="0 0 9.92 13.5"
                v-show="!selected"
              >
                <path class="cls-1" fill="#e8ebfc" d="M31.51,8.57v13.5l-8.9-5a2,2,0,0,1,0-3.48Z" transform="translate(-21.6 -8.57)"/>
              </svg>
            </div>
            <!-- <div class="arrow-outer" v-show="selected"></div>
            <div class="arrow-inner"></div> -->
            {{ item.textarea }}
          </div>
        </div>
        <div class="duration" v-show="selected">{{ duration + 's' }}</div>
        <div class="control" v-show="selected">
          <el-tooltip
            class="item"
            effect="dark"
            content="试听"
            placement="bottom"
          >
            <div class="btn test-play" @click="testPlay">
              <svg viewBox="0 0 1024 1024" width="16" height="16">
                <use :href="testPlayState === 'play' ? '#icon-test-pause' : '#icon-test-play'"></use>
              </svg>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="bottom"
          >
            <div class="btn edit" @click.stop="edit">
              <i
                class="iconfont iconxiugai"
                style="font-size: 16px; color: #737596"
              ></i>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="bottom"
          >
            <div class="btn remove" @click="removeWithConfirm">
              <i
                class="iconfont iconguanbi"
                style="font-size: 16px; color: #737596"
              ></i>
            </div>
          </el-tooltip>
        </div>
      </div>
      <audio
        ref="audio"
        style="width: 0; height: 0"
        :src="$handleAssetsUrl(item.url)"
        @loadedmetadata="onMetaData"
        @ended="ended"
      ></audio>
    </div>
    <voiceEditor
      v-if="editing"
      :voiceData="item"
      :readerOpts="readerOpts"
      :reader="reader"
      :startText="item.textarea"
      :isShowCancel="true"
      :style="{ position: '', 'z-index': 1 }"
      ref="voiceEditor"
      @editDone="editDone"
      @cancel="cancelEdit"
    ></voiceEditor>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import voiceEditor from './voiceEditor.vue';
export default {
  components: {
    voiceEditor
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    readerOpts: {},
    reader: {},
    readerId: {}
  },
  data () {
    return {
      readerData: {},
      duration: 0,
      editing: false,
      selected: false,
      testPlayState: ''
    }
  },
  computed: {
    ...mapGetters([
      'IsOldUser',
      'IsProLevelSystem'
    ]),
    badgeClassName () {
      const isProLevelSystem = this.IsProLevelSystem
      let name = isProLevelSystem ? 'badge pro' : 'badge';
      if (this.readerData.aiType === 2) {
        if (this.IsOldUser) {
          name = 'badge person';
        } else {
          name = isProLevelSystem ? 'badge proPlus' : 'badge enterpriseS';
        }
      }
      return name;
    }
  },
  watch: {
    item: {
      deep: true,
      handler (val) {
        this.getReader();
      }
    },
    editing (val) {
      this.$emit('toggleEditing', val);
    }
  },
  created () {
    this.$bus.on('voiceDisplayerTestPlay', this.onTestPlay);
    this.$bus.on('smartVoice.showVoiceEditor', this.onOutside);
    // this.$bus.on('smartVoice.clickDialog', this.onOutside);
    this.$bus.on('smartVoice.getReadersDone', this.getReader);
    this.$bus.on('smartVoice.selectVoice', this.onSelectVoice);
    this.$bus.on('smartVoice.clickDialog', this.onSelectVoice);

    this.getReader();
  },
  mounted () {
    this.$refs.audio.addEventListener('play', this.onPlay)
    this.$refs.audio.addEventListener('pause', this.onPause)
  },
  beforeDestroy () {
    this.$bus.off('voiceDisplayerTestPlay', this.onTestPlay);
    this.$bus.off('smartVoice.showVoiceEditor', this.onOutside);
    // this.$bus.off('smartVoice.clickDialog', this.onOutside);
    this.$bus.off('smartVoice.getReadersDone', this.getReader);
    this.$bus.off('smartVoice.selectVoice', this.onSelectVoice);
    this.$bus.off('smartVoice.clickDialog', this.onSelectVoice);
  },
  methods: {
    cancelEdit () {
      this.editing = false;
    },
    select () {
      this.selected = !this.selected;
      if (this.selected) {
        this.$bus.emit('smartVoice.selectVoice', this.item);
      }
    },
    onSelectVoice (item) {
      if (!item) {
        this.selected = false;
      }
      if (item && item.filename !== this.item.filename) {
        this.selected = false;
      }
    },
    getReader () {
      const readerId = this.item.queryParams.speakerId;
      let ret = this.readerOpts.find(v => readerId ? v.id === readerId : v.sourceId === this.item.queryParams.speaker);
      this.readerData = ret;
      return ret;
    },
    onMetaData () {
      let dur = this.$refs.audio.duration || 0;
      dur = dur.toFixed(1);
      this.duration = dur;
    },
    testPlay () {
      if (!this.$refs.audio) return
      this.$bus.emit('voiceDisplayerTestPlay', this.item.url);
      if (this.$refs.audio.paused) {
        this.$refs.audio.currentTime = 0;
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
    onPlay () {
      this.testPlayState = 'play';
    },
    onPause () {
      this.testPlayState = '';
    },
    onTestPlay (url) {
      if (!this.$refs.audio) return
      if (url != this.item.url) {
        this.$refs.audio.pause();
      }
    },
    ended () {
      this.$emit('testPlayEnded')
    },
    onOutside (item) {
      if (!item) {
        this.editing = false;
      }
      if (item && item.filename !== this.item.filename) {
        this.eidting = false;
      }
    },
    edit () {
      this.$emit('edit', this.item);
      this.$bus.emit('smartVoice.showVoiceEditor', this.item)
      this.editing = true;
    },
    editDone () {
      this.editing = false;
    },
    removeWithConfirm () {
      this.$modal.show("SubtitleMessageDialog", {
        view: "RemoveSmartVoice",
        resultCallback: (value) => {
          if (value && value.type == "Ok") {
            this.remove();
          }
        }
      });
    },
    remove () {
      let voiceList = this.$store.getters['smartVoice/list'];
      voiceList = voiceList.filter(v => v.filename !== this.item.filename);
      this.$store.commit('smartVoice/setList', voiceList);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 64px;
  margin-bottom: 15px;
}
.voice-displayer {
  display: flex;
  color: #474261;
}
.reader {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 44px;
  margin-right: 20px;
  & .name {
    font-size: 12px;
    color: #474261;
    white-space: nowrap;
  }
}
.figure-wrapper {
  position: relative;
  .badge {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 14px;
    border-radius: 7px;
    color: #fff;
    font-size: 10px;
    content: url(../../../../../static/svg/payTypeSubscript/companyVip.svg);

    &.person {
      width: 36px;
      height: 14px;
      content: url(../../../../../static/svg/payTypeSubscript/commonVip.svg);
      background-image: none;
    }
    &.enterpriseS {
      width: 50px;
      height: 14px;
      content: url(../../../../../static/svg/payTypeSubscript/enterpriseSVIP.svg);
      background-image: none;
    }
    &.pro {
      width: 30px;
      height: 18px;
      content: url(../../../../assets/pro.png);
      background-image: none;
    }
    &.proPlus {
      width: 32px;
      height: 18px;
      content: url(../../../../assets/proPlus.png);
      background-image: none;
    }
  }
}
.figure {
  width: 44px;
  height: 44px;
  background: #d8dee9;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 4px;
  & > img {
    width: 100%;
    height: 100%;
  }
}
.content {
  height: 100%;
  display: flex;
  align-items: center;
  & > .duration {
    min-width: 15px;
    height: 19px;
    margin-left: 10px;
    margin-right: 8px;
  }
  & > .control {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 92px;
    height: 30px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(139, 139, 139, 0.16);
    opacity: 1;
    border-radius: 4px;
    & > .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    & .remove {
      margin-right: 0;
    }
  }
}
.text-wrapper {
  max-width: 378px;
  min-height: 40px;
  cursor: pointer;
  & > .text {
    position: relative;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #e8ebfc;
    border-radius: 4px;
    padding: 11px 10px;
    word-break: break-all;
    &.active {
      border: 1px solid #5778fb;
    }
    & .arrow-outer {
      // box-sizing: content-box;
      position: absolute;
      right: 100%;
      top: 20px;
      transform: translatey(-50%);
      width: 10.41px;
      height: 17.55px;
      &::before {
        content: ' ';
        position: absolute;
        right: -2px;
        top: 50%;
        transform: translateY(-50%);
        height: 17px;
        width: 2.1px;
        background-color: #e8ebfc;
      }
      // border-right: solid 2px #e8ebfc;
      //   width: 0;
      //   height: 0;
      //   border: 11px solid transparent;
      //   border-right-color: #5778FB;
      //   border-right-width: 18px;
      //   border-left-width: 0;
      //   border-top-width: 11px;
      //   border-bottom-width: 11px;
    }
    & .arrow-inner {
      //   width: 0;
      //   height: 0;
      //   border: 10px solid transparent;
      //   border-right-color: #E8EBFC;
      //   border-right-width: 16px;
      //   border-left-width: 0;
      //   border-top-width: 9px;
      //   border-bottom-width: 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/voiceDisplayer.vue